export class QuotationActivityFunctions {
    quantities: number[];
    activity: any;
    section: any;
    mermas: number[];

    constructor(quantities, activity, section, mermas=[]){
        this.quantities = quantities;
        this.activity = activity;
        this.section = section;
        this.mermas = mermas;
    }


    //SECTION
    fijoS(quantity){
        return this.activity.prices[0] || 0;
    }
    qFijoS(quantity, index){
        return this.activity.prices[index];
    }
    fijoTamaño(quantity, index){
        let sizesNeeded = Math.ceil(quantity/(this.section.pieceInSize || 1));
        return (this.activity.prices[0] || 0)*sizesNeeded;
    }
    papel(quantity, index){
        let sizesNoMerma = Math.ceil(quantity/(this.section.pieceInSize || 1));
        let sizesMerma = sizesNoMerma*((100 + this.activity.unique.mermas[index])/100);
        const sheetsNeeded = Math.ceil(sizesMerma/(this.section.sizeInPaper || 1));
        const [priceSheet=0] = this.activity.prices;
        return sheetsNeeded * priceSheet;
    }
    tiros(quantity){
        //console.log('Entered tiros')
        const sizesNeeded = quantity / (this.section.pieceInSize || 1);
        //console.log(sizesNeeded)
        var tiros = 1000*Math.ceil(sizesNeeded/1000);
        //console.log(tiros)
        //ti = 1000 * Math.ceil(ti / 1000);
        //console.log((this.findActivityRange(tiros).price * tiros / 1000) * ( this.section.frontInk + this.section.backInk ))
        return (this.findActivityRange(tiros).price * tiros / 1000)*this.section.frontInk;
    }
    tirosVuelta(quantity){
        //console.log('Entered tiros')
        const sizesNeeded = quantity / (this.section.pieceInSize || 1);
        //console.log(sizesNeeded)
        var tiros = 1000*Math.ceil(sizesNeeded/1000);
        //console.log(tiros)
        //ti = 1000 * Math.ceil(ti / 1000);
        //console.log((this.findActivityRange(tiros).price * tiros / 1000) * ( this.section.frontInk + this.section.backInk ))
        return (this.findActivityRange(tiros).price * tiros / 1000)*this.section.backInk;
    }
    barnizSuaje(quantity){//Es solo barniz, pero no se puede cambiar nombre
        const [fixedPrice=0, pricePerM2=0] = this.activity.prices;
        let totalCm2Stamp = this.section.sheetWidth*this.section.sheetHeight;
        var sizesNeeded = quantity / (this.section.pieceInSize || 1);
        return fixedPrice + ((totalCm2Stamp/10000)*pricePerM2 * sizesNeeded);
    }
    negativos(quantity){
        let {sheetWidth, sheetHeight, frontInk, backInk, changes=1} = this.section;
        let [pricePerCm2=0] = this.activity.prices;
        return sheetWidth*sheetHeight*(frontInk + backInk)*pricePerCm2*changes;
    }
    pegado(quantity){
        let [pricePerThousand=0] = this.activity.prices;
        return pricePerThousand*quantity/1000;
    }
    hotStamping(quantity){
        let totalCm2Stamp = this.section.sheetWidth*this.section.sheetHeight;
        let sizesNeeded = quantity/(this.section.pieceInSize || 1);
        let [plaquesPerSheet=0, pricePerPlaque=0, pricePerRol=0, arregloCost=0, stampWide=0, stampLong=0] = this.activity.prices;
        let capacityWide = Math.floor(61/(stampWide || 1));
        let capacityLong = Math.floor(12000/(stampLong || 1));
        let rols = Math.ceil(quantity/((capacityWide*capacityLong) || 1));
        return rols*pricePerRol + plaquesPerSheet*pricePerPlaque + arregloCost;
    }
    corteFinal(quantity){
        let sizesNeeded = quantity/(this.section.pieceInSize || 1);
        let [downPrice=0, sizesInDown=0, cutQuantity=0] = this.activity.prices;
        return sizesNeeded/sizesInDown*downPrice*cutQuantity || 0;
    }
    suaje(quantity){
        let sizesNeeded = quantity/(this.section.pieceInSize || 1);
        let [linealCm=0, pricePerLinealCm=0, processThousandCost=0] = this.activity.prices;
        return linealCm*pricePerLinealCm*this.section.pieceInSize + processThousandCost*this.perThousand(sizesNeeded);
    }
    placas(quantity){
        let { frontInk, backInk, changes=1 } = this.section;
        let [ pricePerPlaca=0 ] = this.activity.prices;
        return pricePerPlaca*(frontInk + backInk)*changes;
    }
    tintas(quantity, index){
        let { frontInk, backInk, pieceInSize, sizeInPaper, sheetWidth, sheetHeight } = this.section;
        let [ inkKgCost=0, usagePercentage=0 ] = this.activity.prices;
        let INK_FACTOR = 5000;
        let sizesMerma = Math.ceil(quantity/(pieceInSize || 1))*((100 + (this.mermas[index] || 0))/100);
        let sheetsNeeded = Math.ceil(sizesMerma/(sizeInPaper || 1));
        let sizesNeeded = sheetsNeeded*sizeInPaper;
        return (frontInk + backInk)*sizesNeeded*sheetWidth*sheetHeight*(usagePercentage/100)*(inkKgCost/1000)/INK_FACTOR;
    }
    fijoTiroMillar(quantity, index){
        let { pieceInSize } = this.section;
        let [ pricePerThousand=0 ] = this.activity.prices;
        let sizesMerma = Math.ceil(quantity/(pieceInSize || 1))*((100 + (this.mermas[index] || 0))/100);
        return (sizesMerma/1000)*pricePerThousand;
    }
    fijoTintas(quantity){
        let { frontInk, backInk } = this.section;
        let [ pricePerTinta=0 ] = this.activity.prices;
        return (frontInk + backInk)*pricePerTinta;
    }
    //GENERAL
    fijoG(quantity){
        return this.activity.prices[0] || 0;
    }
    qFijoG(quantity, index){
        return this.activity.prices[index];
    }
    desbardado(quantity){
        const pricePiece = this.perThousand(this.activity.prices[0] || 0);
        return quantity * pricePiece;
    }
    empaque(quantity){
        const [pieceInBox=1, priceBox=0] = this.activity.prices;
        return (quantity / pieceInBox) * priceBox || 0;
    }
    fleteLocal(quantity, index){
        const [priceLap=0] = this.activity.prices;
        return priceLap * ( ( (this.activity.unique || {}).laps || [])[index] || 0);
    }
    fleteForaneo(quantity){
        const [pieceInBox=1, priceBox=0] = this.activity.prices;
        return (quantity / pieceInBox) * priceBox || 0;
    }


    //USES
    findActivityRange(quantity){
        var rangeIndex = -1;
        this.activity.ranges.map((range, index) => {
            if(quantity <= range.max && quantity >= range.min){
                rangeIndex = index;
            }
        })
        return rangeIndex === -1 ? { min: 0, max: 0, price: 0 } : this.activity.ranges[rangeIndex];
    }

    get quantityPrices(){
        var quantityPrices: number[] = [];
        this.quantities.map((quantity, index) => {
            quantityPrices.push(+this[this.activity.quantityPricesFunction](quantity, index).toFixed(2));
            if(this.activity.actId == 'BEnUaaNq4GuF7qTyJlQf') console.log(+this[this.activity.quantityPricesFunction](quantity, index).toFixed(2))
        })
        if(this.activity.actId == 'BEnUaaNq4GuF7qTyJlQf') console.log(quantityPrices)
        return quantityPrices;
    }

    perThousand(number){
        return Math.ceil(number/1000);
    }
}

export class QuotationFunctionData{
    functionData = {
        fijoS: { selectName: 'Fijo sección', name: 'fijoS', dataCalc: 1, isGeneral: false, labels: ['Precio'], description: 'El precio es el insertado, independientemente de la cantidad de productos.', hasUnique: false },
        fijoG: { selectName: 'Fijo general', name: 'fijoG', dataCalc: 1, isGeneral: true, labels: ['Precio'], description: 'El precio es el insertado, independientemente de la cantidad de productos.', hasUnique: false },
        qFijoS: { selectName: 'Fijo por cantidad', name: 'qFijoS', dataCalc: 6, isGeneral: false, labels: [...Array(6)].map((u,i) => `Cantidad ${i+1}`), description: 'El precio es el insertado, dependiendo de la cantidad de productos.', hasUnique: false },
        qFijoG: { selectName: 'Fijo por cantidad', name: 'qFijoG', dataCalc: 6, isGeneral: true, labels: [...Array(6)].map((u,i) => `Cantidad ${i+1}`), description: 'El precio es el insertado, dependiendo de la cantidad de productos.', hasUnique: false },
        fijoTamaño: { selectName: 'Fijo x tamaño', name: 'fijoTamaño', dataCalc: 1, isGeneral: false, labels: ['Precio por tamaño'], description: 'El precio es el insertado multiplicado por la cantidad de tamaños.', hasUnique: false },
        papel: { selectName: 'Papel', name: 'papel', dataCalc: 1, isGeneral: false, labels: ['Precio por hoja'], description: 'El precio se obtiene multiplicando la cantidad de hojas por el precio insertado.\nLa cantidad de hojas se obtiene dividiento la cantidad de productos por las piezas que caben en una hoja.', hasUnique: true },
        tiros: { selectName: 'Tiros', name: 'tiros', dataCalc: 0, isGeneral: false, labels: [], description: 'El precio se obtiene con el número de tiros.\nEl número de tiros se obtiene multiplicando la cantidad de tintas frente por la cantidad de tamaños requeridos.', hasUnique: false },
        tirosVuelta: { selectName: 'Tiros Vuelta', name: 'tirosVuelta', dataCalc: 0, isGeneral: false, labels: [], description: 'El precio se obtiene con el número de tiros.\nEl número de tiros se obtiene multiplicando la cantidad de tintas vuelta por la cantidad de tamaños requeridos.', hasUnique: false },
        barnizSuaje: { selectName: 'Barniz', name: 'barnizSuaje', dataCalc: 2, isGeneral: false, labels: ['Costo arreglo', 'Precio por metro cuadrado'], description: '', hasUnique: false },
        desbardado: { selectName: 'Desbardado', name: 'desbardado', dataCalc: 1, isGeneral: true, labels: ['Precio por millar de piezas'], description: '', hasUnique: false },
        empaque: { selectName: 'Empaque', name: 'empaque', dataCalc: 5, isGeneral: true, labels: ['Piezas por caja', 'Precio por caja', 'Medidas Caja Ancho', 'Medidas Caja Largo', 'Medidas Caja Alto'], description: '', hasUnique: false },
        fleteLocal: { selectName: 'Flete local', name: 'fleteLocal', dataCalc: 3, isGeneral: true, labels: ['Precio por vuelta', 'Cantidad de vueltas', 'Piezas por caja'], description: '', hasUnique: true },
        fleteForaneo: { selectName: 'Flete foráneo', name: 'fleteForaneo', dataCalc: 2, isGeneral: true, labels: ['Piezas por caja', 'Precio por caja'], description: '', hasUnique: false },
        negativos: { selectName: 'Negativos', name: 'negativos', dataCalc: 1, isGeneral: false, labels: ['Precio por cm2'], description: 'Ancho de pliego * Largo del pliego * Tintas totales * Precio por cm2 * Cambios', hasUnique: false },
        pegado: { selectName: 'Pegado', name: 'pegado', dataCalc: 1, isGeneral: false, labels: ['Precio por millar'], description: 'Precio por millar * Cantidad / 1000', hasUnique: true },
        hotStamping: { selectName: 'Hot stamping', name: 'hotStamping', dataCalc: 6, isGeneral: false, labels: ['Placas por pliego', 'Precio por placa', 'Precio por rollo', 'Costo arreglo', 'Ancho estampado en cms', 'Largo estampado en cms'], description: '', hasUnique: false },
        maquilaExterna: { selectName: 'Maquila externa', name: 'maquilaExterna', dataCalc: 1, isGeneral: false, labels: ['Precio'], description: 'Precio insertado', hasUnique: false },
        corteFinal: { selectName: 'Corte', name: 'corteFinal', dataCalc: 3, isGeneral: false, labels: ['Precio por bajada', 'Tamaños en una bajada', 'Cantidad de cortes'], description: 'Total bajadas * Precio por bajada * Cantidad de cortes', hasUnique: false },
        suaje: { selectName: 'Suaje', name: 'suaje', dataCalc: 3, isGeneral: false, labels: ['Centímetros lineales de cada pieza', 'Precio por cm lineal', 'Costo del proceso por millar'], description: '', hasUnique: true },
        placas: { selectName: 'Placas', name: 'placas', dataCalc: 1, isGeneral: false, labels: ['Precio por placa'], description: 'Precio por placa * Tintas totales * Cambios', hasUnique: true },
        tintas: { selectName: 'Tintas', name: 'tintas', dataCalc: 2, isGeneral: false, labels: ['Precio de Kg tinta', 'Porcentaje de uso'], description: '', hasUnique: false },
        fijoTiroMillar: {selectName: 'Fijo x Tiro x Millar', name: 'fijoTiroMillar', dataCalc: 1, isGeneral: false, labels: ['Precio por millar'], description: '', hasUnique: false},
        fijoTintas: {selectName: 'Fijo x Tintas', name: 'fijoTintas', dataCalc: 1, isGeneral: false, labels: ['Precio por tinta'], description: '', hasUnique: false},
    }
    selectArray = [
        { name: 'Fijo sección', value: 'fijoS', isGeneral: false },
        { name: 'Fijo general', value: 'fijoG', isGeneral: true },
        { name: 'Fijo por cantidad', value: 'qFijoS', isGeneral: false },
        { name: 'Fijo por cantidad', value: 'qFijoG', isGeneral: true },
        { name: 'Fijo x tamaño', value: 'fijoTamaño', isGeneral: false },
        { name: 'Papel', value: 'papel', isGeneral: false },
        { name: 'Tiros', value: 'tiros', isGeneral: false },
        { name: 'Tiros Vuelta', value: 'tirosVuelta', isGeneral: false },
        { name: 'Barniz', value: 'barnizSuaje', isGeneral: false },
        { name: 'Desbardado', value: 'desbardado', isGeneral: true },
        { name: 'Empaque', value: 'empaque', isGeneral: true },
        { name: 'Flete local', value: 'fleteLocal', isGeneral: true },
        { name: 'Flete foráneo', value: 'fleteForaneo', isGeneral: true },
        { name: 'Negativos', value: 'negativos', isGeneral: false },
        { name: 'Pegado', value: 'pegado', isGeneral: false },
        { name: 'Hot stamping', value: 'hotStamping', isGeneral: false },
        { name: 'Maquila externa', value: 'maquilaExterna', isGeneral: false },
        { name: 'Corte', value: 'corteFinal', isGeneral: false },
        { name: 'Suaje', value: 'suaje', isGeneral: false },
        { name: 'Placas', value: 'placas', isGeneral: false },
        { name: 'Tintas', value: 'tintas', isGeneral: false },
        { name: 'Fijo x Tiro x Millar', value: 'fijoTiroMillar', isGeneral: false },
        { name: 'Fijo x Tintas', value: 'fijoTintas', isGeneral: false },
    ]
}
